(ns pfo.widget.modal
  (:require
    [dommy.utils]
    [pfo.util :as util]))

(defn modal [_ state]
  (let [close (util/handler (fn []
                              (swap! state assoc :enabled false)
                              (some-> (:close-cb @state) (apply []))))]
    (fn [component state]
      [:div.modal
       (when (:enabled @state)
         [:div.modal-fade-screen
          (merge
           (when (:lower-layer @state) {:style {:z-index "9997"}})
           {:on-click close}
           (when (:enabled @state) {:class "enabled"}))
          [:div.modal-inner {:on-click (fn [event] (.stopPropagation event))}
           [:div.modal-close {:on-click close}]
           [:div.modal-component component]]])])))

;; Yes, modal-window is a dumb name, but better than modal2, which it is.
(defn modal-window [& _]
  (fn [component {:keys [close-cb
                         close-disable
                         is-enabled-fn
                         lower-layer
                         modal-class
                         modal-style
                         scroll-top
                         x
                         y]}]
    (let [close (util/handler close-cb)]
      [:div.modal
       (when (is-enabled-fn)
         [:div.modal-fade-screen
          (merge
           {:on-click close}
           {:class (util/classes
                     (when (is-enabled-fn) "enabled")
                     (when modal-class modal-class))}
           {:style (merge nil
                     (when lower-layer {:z-index "9997"})
                     (when scroll-top {:top (str scroll-top "px")})
                     (when modal-style modal-style))})
          [:div.modal-inner (merge
                             {:on-click (fn [event] (.stopPropagation event))}
                             (when (or x y) {:style {:left (str x "px") :top (str y "px")}}))
           (when-not close-disable
             [:div.modal-close {:on-click close}])
           [:div.modal-component component]]])])))

; @see client/scss/modal.scss : div.modal-on
(defn modal-menu [state toggle-menu]
  [:div.modal-menu {:class (when (:enabled @state) "modal-on" ) :on-click #(toggle-menu) }])
